$(document).ready(function () {

    var newsLetter = new NewsLetter();

    // Função para verificar se algum dos ancestrais possui a classe faixa-comunicado
    function isAncestorFaixaComunicado(newsForm) {
        return newsForm.closest('.faixa-comunicado').length > 0;
    }

    $('#js-form-news').submit(function(event) {
        event.preventDefault();

        $('#js-form-news').addClass('form-news-sending')

        var data = {
            'email': $(this).find('#email').val()
        }

        var action = newsLetter.addEmail(data);

        var newsLetterBox = $('#js-form-news').closest('#newsletter').find('.modal-newsletter');
        var newsLetterMessage = $('#js-form-news').closest('#newsletter').find('.newsletter__content--message');
        var newsForm = $('#js-form-news').closest('#newsletter').find('.newsletter__form');

        $(newsLetter).bind('onSuccessAddEmailNewsLetter', function(event, data) {
            event.preventDefault();
                newsLetterBox.addClass('is-active');
                newsLetterMessage.html('<i class="icon-svg-success-newsletter"></i> OBRIGADO POR PARTICIPAR, CONFIRA SEU E-MAIL!').addClass('success');
                
                setTimeout(function() {
                    newsLetterBox.removeClass('is-active');
                    newsLetterMessage.removeClass('success');
                    newsForm.removeClass('form-news-sending');
                }, 4000);
        }).bind('onFailAddEmailNewsLetter500', function(event, data, jqXHR, textStatus, errorThrown){
                newsLetterBox.addClass('is-active');
                newsLetterMessage.html('<i class="icon-svg-error-close icon-close"></i> O email já está cadastrado!').addClass('error');
                
                setTimeout(function() {
                    newsLetterBox.removeClass('is-active');
                    newsLetterMessage.removeClass('error');
                    newsForm.removeClass('form-news-sending');
                }, 4000);
                
                newsLetterBox.addClass('is-active');
                newsLetterMessage.html(data.email[0]).addClass('error');
        }).bind('onFailAddEmailNewsLetter', function(event, data, jqXHR, textStatus, errorThrown){
                event.preventDefault();
                console.log('Error: ', data);
                newsLetterBox.addClass('is-active');
                newsLetterMessage.html('<section class="header"><i class="icon-svg-error-close icon-close"></i></section><section class="body">' + data.email[0] + '</section>').addClass('error');
                
                setTimeout(function() {
                    newsForm.removeClass('form-news-sending');
                    newsLetterBox.removeClass('is-active');
                    setTimeout(function() { newsLetterMessage.removeClass('error') }, 1220 );
                    $('#email').attr('placeholder', 'Email').removeClass('is-error');
                }, 4000);
        }).bind('onAlwaysAddEmailNewsLetter', function(event, data_or_jqXHR, textStatus, jqXHR_or_errorThrown){
            if (isAncestorFaixaComunicado(newsForm)) {
                // Ação a ser tomada sempre
            }
        });
    });

    $('#js-form-news-2').submit(function(event) {
        event.preventDefault();

        var couponText = $(this).attr('coupon') ? $(this).attr('coupon') : 'PRIMEIRACOMPRA10';

        $('#js-form-news-2').addClass('form-news-sending')

        var data = {
            'email': $(this).find('#email_2').val()
        }

        var action = newsLetter.addEmail(data);

        var newsLetterBox = $('#js-form-news-2').closest('#newsletter').find('.modal-newsletter');
        var newsLetterMessage = $('#js-form-news-2').closest('#newsletter').find('.newsletter__content--message');
        var newsForm = $('#js-form-news-2').closest('#newsletter').find('.newsletter__form');

        $(newsLetter).bind('onSuccessAddEmailNewsLetter', function(event, data) {
            event.preventDefault();
            if (isAncestorFaixaComunicado(newsForm)) {
                newsLetterBox.addClass('is-active');
                newsLetterMessage.html(`<section class="close"><i class="icon-svg-error-close icon-close ovo" onclick="closeNewsletter()"></i></section><div class="col-12 text-center px-0"> <p class="title-newsletter-sucess">VOCÊ GANHOU!</p> <p class="subtitle-newsletter-sucess">R$10 PARA A PRIMEIRA COMPRA</p> </div><div class="col-12 input-group d-flex justify-content-center pr-0 my-4"> <input type="text" id="URL" value="${couponText}" readonly=“true” name="text" class="newsletter__input mt-3 input-email newsletter__cupom text-center"> <button class="button-clipboard">COPIAR CUPOM</button> </div> <span class="message-success">Cupom copiado com sucesso </span> </div>`).addClass('success');
                
                var buttonClipboard = $('.button-clipboard');
        
                
        
                buttonClipboard.on("click", function(event) {
                    event.preventDefault()
                    $('.newsletter__cupom') [0].select()
                    document.execCommand("copy")
                    $('.message-success').addClass('active');
                }
                )
        
                // $('#email').val('').attr('placeholder', 'Email enviado com sucesso').addClass('is-success');
                setTimeout(function() {
                    newsLetterBox.removeClass('is-active');
                    newsLetterMessage.removeClass('success');
                    // $('#email').attr('placeholder', 'Email').removeClass('is-success')
        
                    newsForm.removeClass('form-news-sending')
        
                }, 999999);
            }
        }).bind('onFailAddEmailNewsLetter500', function(event, data, jqXHR, textStatus, errorThrown){
                newsLetterBox.addClass('is-active');
                newsLetterMessage.html('<i class="icon-svg-error-close icon-close"></i> O email já está cadastrado!').addClass('error');
                
                setTimeout(function() {
                    newsLetterBox.removeClass('is-active');
                    newsLetterMessage.removeClass('error');
                    newsForm.removeClass('form-news-sending');
                }, 4000);
                
                newsLetterBox.addClass('is-active');
                newsLetterMessage.html(data.email[0]).addClass('error');
        }).bind('onFailAddEmailNewsLetter', function(event, data, jqXHR, textStatus, errorThrown){
                event.preventDefault();
                console.log('Error: ', data);
                newsLetterBox.addClass('is-active');
                newsLetterMessage.html('<section class="header"><i class="icon-svg-error-close icon-close"></i></section><section class="body">' + data.email[0] + '</section>').addClass('error');
                
                setTimeout(function() {
                    newsForm.removeClass('form-news-sending');
                    newsLetterBox.removeClass('is-active');
                    setTimeout(function() { newsLetterMessage.removeClass('error') }, 1220 );
                    $('#email').attr('placeholder', 'Email').removeClass('is-error');
                }, 4000);
        }).bind('onAlwaysAddEmailNewsLetter', function(event, data_or_jqXHR, textStatus, jqXHR_or_errorThrown){
            if (isAncestorFaixaComunicado(newsForm)) {
                // Ação a ser tomada sempre
            }
        });
    });

    
    
});